var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('header-nav')],1),_c('div',{staticClass:"content"},[_c('keep-alive',[_c('router-view')],1)],1),_c('div',{staticClass:"line",staticStyle:{"height":"30px"}}),_c('div',{staticClass:"footer"},[_c('footerNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }